<template>
  <div class="payment-audit-dialog">
    <el-dialog v-dialog-drag :title="readonly ? '认领详情' : '审核信息'" :visible.sync="showDialog" width="800px" :destroy-on-close="true"
      append-to-body :before-close="cancel" class="audit-dialog">
      <div class="el-dialog-div">
        <!-- 审核操作区域 -->
        <div class="section-card audit-section" v-if="!readonly">
          <div class="section-header-bar">
            <span class="section-title"><i class="el-icon-s-check"></i> 审核操作</span>
            <el-button size="small" type="success" icon="el-icon-check" @click="handle">确认审核</el-button>
          </div>
          <el-form label-width="110px" ref="form" :model="form" class="audit-form">
            <el-form-item label="审核结果" prop="status" :rules="{ required: true, message: '审核结果不能为空', trigger: 'change' }">
              <el-radio v-model="form.status" label="SUCCESS">
                <i class="el-icon-success" style="color: #67c23a;"></i> 通过
              </el-radio>
              <el-radio v-model="form.status" label="DEFEAT">
                <i class="el-icon-error" style="color: #f56c6c;"></i> 驳回
              </el-radio>
            </el-form-item>
            <el-form-item label="驳回原因" prop="rejectionReason" v-if="form.status === 'DEFEAT'"
              :rules="{ required: true, message: '驳回原因不能为空', trigger: 'change' }">
              <el-input style="width: 100%;" type="textarea" rows="3" maxlength="300" show-word-limit placeholder="请输入驳回原因"
                v-model="form.rejectionReason" clearable>
              </el-input>
            </el-form-item>
          </el-form>
        </div>

        <!-- 认领信息详情 -->
        <div class="section-card">
          <div class="section-header-bar" @click="toggleSection('claimInfo')">
            <div class="section-title"><i class="el-icon-info"></i> 认领信息详情</div>
            <i :class="sectionOpen.claimInfo ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </div>
          <div v-show="sectionOpen.claimInfo">
            <div class="detail-grid">
              <div class="detail-item" v-if="selectDetail?.['annex']?.['CLAIM_THE_INVOICE_ANNEX']">
                <span class="detail-label">认领附件</span>
                <span class="detail-value">
                  <div class="attachment-actions">
                    <el-button size="mini" type="primary" icon="el-icon-download"
                      @click="download(form.id, 'CLAIM_THE_INVOICE_ANNEX')">下载</el-button>
                    <el-button size="mini" type="primary" icon="el-icon-view"
                      @click="preview(form.id, 'CLAIM_THE_INVOICE_ANNEX')">预览</el-button>
                  </div>
                </span>
              </div>
              <div class="detail-item full-width">
                <span class="detail-label">认领备注</span>
                <span class="detail-value">{{ selectDetail.remark }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 到款信息详情 -->
        <div class="section-card">
          <div class="section-header-bar" @click="toggleSection('paymentInfo')">
            <div class="section-title"><i class="el-icon-money"></i> 到款信息详情</div>
            <i :class="sectionOpen.paymentInfo ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </div>
          <div v-show="sectionOpen.paymentInfo">
            <div class="detail-grid">
              <div class="detail-item">
                <span class="detail-label">合同编号</span>
                <span class="detail-value">
                  <el-link :underline="false" v-for="(contractNumber, index) in payment.data.contractNumbers" :key="index"
                    type="primary" @click="openContractDialog(contractNumber)">{{ contractNumber + (index !==
                    payment.data.contractNumbers.length - 1 ? ',' : '') }}</el-link>
                </span>
              </div>
              <div class="detail-item">
                <span class="detail-label">付款单位</span>
                <span class="detail-value">{{ payment.data.invoiceTitle }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">发票号码</span>
                <span class="detail-value">
                  <el-link :underline="false" type="primary" @click="openTicketsDialog(payment.data.invoiceId)">{{
                    payment.data['invoiceInfoDTO'].invoiceNumber}}</el-link>
                </span>
              </div>
              <div class="detail-item">
                <span class="detail-label">发票金额</span>
                <span class="detail-value"><span class="amount-text">{{ payment.data['invoiceInfoDTO'].invoiceAmount }}</span></span>
              </div>
              <div class="detail-item">
                <span class="detail-label">到款金额</span>
                <span class="detail-value"><span class="amount-text">{{ payment.data.paymentAmount }}</span></span>
              </div>
              <div class="detail-item">
                <span class="detail-label">到款时间</span>
                <span class="detail-value">{{ payment.data.paymentDate }}</span>
              </div>
              <div class="detail-item full-width">
                <span class="detail-label">到款备注</span>
                <span class="detail-value">{{ payment.data.remark }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <contract-details v-if="showContractDetails" :show-dialog="showContractDetails" :select-detail="[ContractDetail]"
      @submit="close1"></contract-details>
    <tickets-details v-if="showTicketsDetails" :show-dialog="showTicketsDetails" :select-detail="TicketsDetail"
      @submit="close2"></tickets-details>
    <file-preview v-if="showFile" :show-dialog="showFile" :response="fileInfo" @submit="close"></file-preview>
    <loading :loading="loading" load-text="提交中"></loading>
  </div>

</template>

<script>

import { getDataInLocalStorage } from "@/utils/localStorage";
import {attachmentDownload, auditInfo} from "@/api/dilivery/audit";
import {getContractPage} from "@/api/dilivery/sales/contract";
import {getTicketsPage} from "@/api/dilivery/tickets";
import ContractDetails from "@/components/sales/ContractDetails.vue";
import TicketsDetails from "@/components/tickets/TicketsDetails.vue";
import FilePreview from "@/components/file/FilePreview.vue";
import Loading from "@/components/loading/Loading.vue";
const baseURL = process.env.VUE_APP_BASE_API

export default {
  name: "PaymentAuditDialog",
  components: { FilePreview, TicketsDetails, ContractDetails, Loading },
  props:['showDialog','selectDetail','readonly'],
  data() {
    return {
      payment: {},
      loading:false,
      showFile:false,
      fileInfo:null,
      sectionOpen: {
        claimInfo: true,
        paymentInfo: true,
      },
      showContractDetails:false,
      ContractDetail:'',
      showTicketsDetails:false,
      TicketsDetail:'',
      form:{
        id: '',
        status: '',
        rejectionReason: ''
      },
    };
  },
  watch:{
    selectDetail:{
      handler(newVal){
        if(newVal&&Object.keys(newVal)){
          this.form.id = newVal.id
          this.payment = {...newVal}
        }
      },
      immediate:true
    }
  },
  methods: {
    toggleSection(section) {
      this.sectionOpen[section] = !this.sectionOpen[section];
    },
    cancel() {
      this.$emit('submit','cancel')
    },
    openContractDialog(contractNumber){
      let param = {}
      let data = {
        "query#contractNumber.EQ":contractNumber
      }
      getContractPage(param,data).then(res=>{
        if(res.code === 200){
          if(res.data.records.length === 0){
            this.$messageUi.error("打开合同详情失败")
          }else{
            this.ContractDetail = res.data.records[0]
            this.showContractDetails = true
          }
        }
      }).catch(error=>{})
    },
    openTicketsDialog(id){
      let param = {}
      let data = {
        "query#id.EQ":id
      }
      getTicketsPage(param,data).then(res=>{
        if(res.code === 200){
          if(res.data.records.length === 0){
            this.$messageUi.error("打开发票详情失败")
          }else{
            this.TicketsDetail = res.data.records[0]
            this.showTicketsDetails = true
          }
        }
      }).catch(error=>{})
    },
    close1(){
      this.showContractDetails = false
    },
    close2(){
      this.showTicketsDetails = false
    },
    handle(){
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          auditInfo(this.form).then(res => {
            this.loading = false
            if (res.code === 200) {
              this.$store.commit('right/setChangeRed', true)
              this.$emit('submit','confirm')
              if(this.form.status === 'SUCCESS'){
                this.$messageUi.success('已通过')
              }else{
                this.$messageUi.success('已驳回')
              }
            }
          }).catch(err => {
            this.loading = false
          })
        } else {
          this.$nextTick(() => {
            let err = document.getElementsByClassName('is-error')
            if (err.length) {
              err[0].scrollIntoView({
                block: 'center',
                behavior: 'smooth',
              })
            }
          })
          this.$messageUi.error('填写参数不规范，请检查')
        }
      });
    },
    async download(id,type){
      try {
        let url = `${baseURL}/audit-info/attachment/${id}/${type}?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`
        const elink = document.createElement('a')
        elink.href = url
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink);
      } catch (error) {
        console.log(error);
      }
    },
    async preview(id,type){
      try {
        this.fileInfo = await attachmentDownload(id,type);
        this.showFile = true
      } catch (error) {
        console.log(error);
      }
    },
    close(){
      this.showFile = false
      this.fileInfo = null
    },
  }
};
</script>

<style lang="scss" scoped>
.payment-audit-dialog {
  ::v-deep .audit-dialog {
    .el-dialog__header {
      
      padding: 15px 20px;
      
       .el-dialog__title {
        font-weight: 600;
      }
      
      
    }
    
    .el-dialog__body {
      padding: 20px;
    }
  }
}
@import "@/assets/css/mixins.scss";
@import "@/assets/css/detail.css";
.el-dialog-div {
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 5px;
  
  @include thin-scrollbar(8px, #888);
}

.audit-section {
  background: linear-gradient(135deg, #f5f7fa 0%, #fff 100%);
}

.audit-form {
  padding: 16px;
}

</style>
